module.exports = __webpack_public_path__ + "img/icon-managing-authentication-title.svg";